// extracted by mini-css-extract-plugin
module.exports = {"RangeSlider":"RangeSlider_RangeSlider__2k7l_","LabelNote":"RangeSlider_LabelNote__AkMJe"};